import { Box, Typography } from "@mui/material";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Table from "../../components/table/Table";
import HomeLayout from "../../layouts/Home";

const HospitalHmoHistory = () => {
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
    length: 0,
    hidden: false,
  });

  const rows = [];

  return (
    <HomeLayout {...{ title: "Transaction Management" }}>
      <SearchBar placeholder="Search For Transactions..." />
      <Box
        className="pt-8 px-8 mt-5 bg-[var(--c-bg-color)] rounded-lg w-100%"
        sx={{ p: 0 }}
      >
        <Typography className="text-[400] text-xl text-[#040316]">
          H. M. O Transaction History
        </Typography>
        <Table
          {...{
            dropdownMenu: rows,
            data: rows,
            pagination,
            setPagination,
          }}
        />
      </Box>
    </HomeLayout>
  );
};

export default HospitalHmoHistory;
